import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function minArrayLength(min = 1): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (value.length >= min) return null;

    return { minLength: true };
  };
}
